import React, { forwardRef } from "react";

import imgAguarde from "../assets/aguarde.gif";

interface IPros {
  full?: boolean;
}

const LoadingReport = forwardRef((props: IPros, ref: any) => {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",
        width: "100%",
        position: props.full ? "absolute" : "relative",
        height: "100%",
        minHeight: "10vh",
        zIndex: 9999,
        opacity: 0.8,
        top: 0,
        left: 0,
      }}
    >
      <img
        style={{ height: 150, width: 150 }}
        src={imgAguarde}
        alt="Aguarde..."
      />
      <div style={{ color: "black", fontSize: 20 }}>
        Aguarde, gerando relatório...
      </div>
    </div>
  );
});

export default LoadingReport;
